import createHistory from 'history/createBrowserHistory';
const customHistory = createHistory();
export default customHistory;